import NavigationContainer from './navigation-container';

export default NavigationContainer;
